<p>Najmniejsza temperatura: {{getMinTemp()}}</p>
<p>Największa temperatura: {{getMaxTemp()}}</p>
<p>Średnia temperatura: {{getAvgTemp()}}</p>
<p>Ilość łącznych wyszukiwań: {{historyservice.searchHistory.length}}</p>
